<script>
  import {EventBus} from '@/handler/event-bus'  
  import { Pie, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins

  export default {
    extends: Pie,
    mixins: [reactiveProp],
    props: {
      chartData: {
        type: Object,
        default: {}
      },  
      options: {
        type: Object,
        default: {}
      },        
    },       
    mounted () {        
      this.render()
    },
    watch: {
      chartData: function() {        
        this.$data._chart.update()
      },
    }, 
    methods: {
      render() {
        this.renderChart(this.chartData, this.options) 
      }
    }
  }
</script>
